// Helper centralizado para armar links del flow de signup.
//
// Sprint 3 B3: en lugar de hardcodear `https://gonix.jeroz.dev` en cada
// caller (InvitacionModal, futuras pantallas, copy de WhatsApp templates),
// derivamos del entorno. Para futuro: cambio de dominio + multi-env
// (staging) es 1 var.
//
// Orden de resolución:
//   1. VITE_APP_PUBLIC_URL si está seteada (recomendado en Vercel prod).
//   2. window.location.origin como fallback (dev local + casos donde la
//      var no está seteada). Funciona pero NO sirve para links que se
//      van a copiar y pegar — el origin de localhost no le sirve al
//      paciente del kine.
//
// El caller debe saber esto: en dev sin var, el link va a apuntar a
// http://localhost:5173 y solo va a funcionar en la misma máquina.
// Para piloto en producción, VITE_APP_PUBLIC_URL DEBE estar seteada
// (Vercel → Environment Variables → Production).

const FALLBACK_ORIGIN = "https://gonix.jeroz.dev";

/** Devuelve la base URL pública de la app, sin trailing slash. */
export function getAppPublicUrl(): string {
  const envUrl = import.meta.env.VITE_APP_PUBLIC_URL as string | undefined;
  if (envUrl && envUrl.length > 0) {
    return envUrl.replace(/\/$/, "");
  }
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  return FALLBACK_ORIGIN;
}

/** Arma el link de signup del paciente con el token UUID. */
export function getPacienteSignupLink(token: string): string {
  return `${getAppPublicUrl()}/signup-paciente?token=${encodeURIComponent(token)}`;
}

/** Arma el texto pre-rellenado para enviar por WhatsApp. */
export function getInvitacionWhatsappText(
  nombrePaciente: string,
  signupLink: string,
): string {
  return (
    `Hola ${nombrePaciente}, te invité a Gonix para hacer tus ejercicios ` +
    `de rehabilitación.\n\n` +
    `Activá tu cuenta acá: ${signupLink}\n\n` +
    `El link vence en 7 días.`
  );
}

/** Arma la URL completa de wa.me con texto pre-rellenado. Si hay telefono,
 *  lo incluye (debe estar en formato internacional sin + ni espacios para
 *  WhatsApp — el helper limpia lo que puede). Si no, wa.me abre el picker
 *  de contacto. */
export function getWhatsappShareUrl(
  text: string,
  telefono?: string | null,
): string {
  const encoded = encodeURIComponent(text);
  if (telefono) {
    const cleaned = telefono.replace(/[\s+\-()]/g, "");
    if (cleaned.length > 0) {
      return `https://wa.me/${cleaned}?text=${encoded}`;
    }
  }
  return `https://wa.me/?text=${encoded}`;
}
